import './style.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { LanguageProvider } from "./components/utils/LanguageContext";

const root = ReactDOM.createRoot(document.querySelector('#root'));


root.render(
  <React.StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>
);
